// utils/colors.js

// Chip colors for different components
export const getChipColors = (isDark) => ({
    location: {
      active: {
        bg: isDark ? "rgba(22, 163, 74, 0.2)" : "#dcfce7",
        text: isDark ? "#4ade80" : "#16a34a",
        border: isDark ? "#4ade80" : "#16a34a",
        hoverBg: isDark ? "rgba(22, 163, 74, 0.3)" : "#dcfce7",
      },
      inactive: {
        bg: isDark ? "transparent" : "white",
        text: undefined, // Will use text.secondary from theme
        border: isDark ? "rgba(255, 255, 255, 0.2)" : undefined, // Will use divider
        hoverBg: isDark ? "rgba(22, 163, 74, 0.15)" : "rgba(22, 163, 74, 0.06)",
      },
    },
    mode: {
      buy: {
        main: isDark ? "#60a5fa" : "#2563eb",
        bg: isDark ? "rgba(37, 99, 235, 0.2)" : "#dbeafe",
        hoverBg: isDark ? "rgba(37, 99, 235, 0.3)" : "#bfdbfe",
        selectedBg: isDark ? "rgba(37, 99, 235, 0.15)" : "rgba(37, 99, 235, 0.08)",
      },
      sell: {
        main: isDark ? "#fbbf24" : "#d97706",
        bg: isDark ? "rgba(217, 119, 6, 0.2)" : "#fef3c7",
        hoverBg: isDark ? "rgba(217, 119, 6, 0.3)" : "#fde68a",
        selectedBg: isDark ? "rgba(217, 119, 6, 0.15)" : "rgba(217, 119, 6, 0.08)",
      },
    },
    type: {
      product: {
        main: isDark ? "#38bdf8" : "#0284c7",
        bg: isDark ? "rgba(2, 132, 199, 0.2)" : "#e0f2fe",
        hoverBg: isDark ? "rgba(2, 132, 199, 0.3)" : "#bae6fd",
        selectedBg: isDark ? "rgba(2, 132, 199, 0.15)" : "rgba(2, 132, 199, 0.08)",
      },
      service: {
        main: isDark ? "#a78bfa" : "#7c3aed",
        bg: isDark ? "rgba(124, 58, 237, 0.2)" : "#ede9fe",
        hoverBg: isDark ? "rgba(124, 58, 237, 0.3)" : "#ddd6fe",
        selectedBg: isDark ? "rgba(124, 58, 237, 0.15)" : "rgba(124, 58, 237, 0.08)",
      },
    },
  });
  
  // Semantic colors for status, alerts, etc.
  export const getSemanticColors = (isDark) => ({
    success: {
      main: isDark ? "#4ade80" : "#16a34a",
      bg: isDark ? "rgba(22, 163, 74, 0.2)" : "#dcfce7",
      border: isDark ? "rgba(22, 163, 74, 0.4)" : "#16a34a",
    },
    warning: {
      main: isDark ? "#fbbf24" : "#d97706",
      bg: isDark ? "rgba(217, 119, 6, 0.2)" : "#fef3c7",
      border: isDark ? "rgba(217, 119, 6, 0.4)" : "#d97706",
    },
    error: {
      main: isDark ? "#f87171" : "#dc2626",
      bg: isDark ? "rgba(220, 38, 38, 0.2)" : "#fee2e2",
      border: isDark ? "rgba(220, 38, 38, 0.4)" : "#dc2626",
    },
    info: {
      main: isDark ? "#38bdf8" : "#0284c7",
      bg: isDark ? "rgba(2, 132, 199, 0.2)" : "#e0f2fe",
      border: isDark ? "rgba(2, 132, 199, 0.4)" : "#0284c7",
    },
  });
  
  // Surface colors for cards, papers, etc.
  export const getSurfaceColors = (isDark) => ({
    elevated: {
      bg: isDark ? "#1e1e1e" : "#ffffff",
      border: isDark ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.08)",
      shadow: isDark ? "0 4px 20px rgba(0, 0, 0, 0.4)" : "0 4px 20px rgba(0, 0, 0, 0.1)",
    },
    subtle: {
      bg: isDark ? "rgba(255, 255, 255, 0.05)" : "rgba(0, 0, 0, 0.02)",
      hover: isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.04)",
    },
  });
  
  // Category card colors (adjusts category colors for dark mode)
  export const getCategoryCardColors = (categoryColor, isDark) => ({
    bg: isDark ? `${categoryColor}15` : `${categoryColor}10`,
    border: isDark ? `${categoryColor}30` : "transparent",
    hoverBorder: categoryColor,
    hoverShadow: isDark ? `0 4px 12px ${categoryColor}30` : "0 4px 12px rgba(0,0,0,0.1)",
    iconBg: isDark ? `${categoryColor}25` : `${categoryColor}20`,
    text: isDark ? undefined : categoryColor, // undefined uses theme text.primary
  });